import { render, staticRenderFns } from "./StatisticsAccountCreate.vue?vue&type=template&id=6c662568&"
import script from "./StatisticsAccountCreate.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports